import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Grid, Pagination } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initAccreditationCards() {
  Alpine.data(
    'accreditationCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.accreditationCards__slider');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Grid, Pagination],
          slidesPerView: 1,
          spaceBetween: 20,
          grid: {
            rows: 4,
            fill: 'row',
          },
          pagination: {
            // @ts-ignore
            el: `#${this.$el.id} .swiper-pagination`,
            clickable: true,
          },
          breakpoints: {
            992: {
              slidesPerView: 2,
              spaceBetween: 20,
              grid: {
                rows: 5,
                fill: 'row',
              },
            },
          },
        });
      },
    }),
  );
}
